module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/laboral-doc/laboral-doc.component.css
// module id = ./src/app/components/laboral-doc/laboral-doc.component.css
// module chunks = main